interface EntryFormSectionHeadingProps {
  /** "01" 처럼 두 자리로 적는 단계 번호 */
  step: string
  title: string
  description: string
}

/** 단계 번호는 브랜드 레드 사각 배지로 붙여 폼의 진행을 보이게 한다 */
export default function EntryFormSectionHeading({
  step,
  title,
  description,
}: Readonly<EntryFormSectionHeadingProps>) {
  return (
    <div className="flex gap-3">
      <span
        aria-hidden="true"
        className="app-txt-caption flex size-7 shrink-0 items-center justify-center bg-app-primary-500 font-black text-app-text-100"
      >
        {step}
      </span>
      <div>
        <h2 className="app-txt-h3">
          <span className="sr-only">STEP {step} — </span>
          {title}
        </h2>
        <p className="app-txt-body2 mt-1 text-app-text-200">{description}</p>
      </div>
    </div>
  )
}
